import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const HomeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
  </svg>
)


const Breadcrumb = ({ category, productTitle }) => {
  const navigate = useNavigate()

  const handleCategoryClick = (e) => {
    e.preventDefault()
    navigate('/', { state: { selectedCategory: category } })
  }

  return (
    <div className="bg-gray-100 py-2 px-4 border-b border-gray-200">
      <div className="max-w-7xl mx-auto">
        <nav className="flex" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-2">
            <li>
              <Link 
                to="/" 
                className="inline-flex items-center px-2.5 py-1.5 rounded-md text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-200 transition-colors border border-gray-200"
              >
                <HomeIcon />
              </Link>
            </li>
            {category && (
              <>
                <li className="text-gray-400">/</li>
                <li>
                  <button
                    onClick={handleCategoryClick}
                    className="inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium bg-grey-50 text-gray-700 hover:bg-gray-200 transition-colors border border-gray-200"
                  >
                    {/* <CategoryIcon /> */}
                    {category}
                  </button>
                </li>
              </>
            )}
            {productTitle && (
              <>
                <li className="text-gray-400">/</li>
                <li className="text-gray-900 px-2.5 py-1.5 text-sm font-medium" aria-current="page">
                  {productTitle}
                </li>
              </>
            )}
          </ol>
        </nav>
      </div>
    </div>
  )
}

export default Breadcrumb 